<template>
  <div class="flex">
    <div v-for="(star, index) in stars" :key="index" class="w-1/5">
      <icon :name="star.filled ? 'star-filled' : 'star'" class="text-yellow-500 w-full h-full"></icon>
    </div>
  </div>
</template>

<script>
  import Icon from '@/Shared/Icon';

  export default {
    props: ['rating'],
    components: {Icon},
    data() {
      return {
        stars: [{filled: false}, {filled: false}, {filled: false}, {filled: false}, {filled: false}],
      }
    },
    mounted() {
      this.setRating(this.rating)
    },
    methods: {
      setRating(rate) {
        this.stars.map((star, index) => star.filled = index < rate);
      }
    }
  };
</script>
